export default {"src":"/_next/static/media/cryptorank.202cd9cc.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};